import {
  createMultiplexerAutoCompletionProvider,
  createTextAutoCompletionProvider,
} from '@datacamp/code-editor';
import { useMemo } from 'react';

import { getCodeExecutionBackend } from '../../helpers/codeExecutionBackend';

const getMultiplexerAutoCompletionProvider = ({
  pec,
  sct,
  solution,
  type,
}: any) => {
  return createMultiplexerAutoCompletionProvider({
    exerciseDetails: {
      pec,
      sct,
      solution,
      type,
    },
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    multiplexerClient: getCodeExecutionBackend()!,
  });
};

const useAutoCompletionProviders = ({
  language,
  pec,
  sct,
  solution,
  type,
}: any) => {
  const textAutoCompletionProvider = useMemo(
    () => createTextAutoCompletionProvider(),
    [],
  );
  const multiplexerAutoCompletionProvider = useMemo(
    () => getMultiplexerAutoCompletionProvider({ pec, sct, solution, type }),
    [pec, sct, solution, type],
  );

  const providers = useMemo(() => {
    if (type === 'RCppExercise') {
      return [textAutoCompletionProvider];
    }
    if (!['r', 'python'].includes(language)) {
      return [textAutoCompletionProvider];
    }
    if (language === 'python') {
      return [textAutoCompletionProvider];
    }
    return [textAutoCompletionProvider, multiplexerAutoCompletionProvider];
  }, [
    textAutoCompletionProvider,
    multiplexerAutoCompletionProvider,
    type,
    language,
  ]);

  return providers;
};

export default useAutoCompletionProviders;
